import React from 'react';
import { Button, SmallHeader, Suspense } from '@axiom/ui';

import { Header } from '../../components/Header/Header';
import { Banner } from '../../components/Banner/Banner';

import { ErrorBoundaryLayoutWrapper } from './ErrorBoundaryLayoutStyles';

export const ErrorBoundaryLayout = () => {
  return (
    <>
      <Header closeSideDrawer={() => {}} />
      <Suspense fallback={null}>
        <Banner />
      </Suspense>
      <div id="top" />
      <ErrorBoundaryLayoutWrapper>
        <SmallHeader>
          There was a problem displaying this page. We apologize for any
          inconvenience. Please try again, and if the issue continues, reach out
          to your Axiom contact for assistance.
        </SmallHeader>
        <Button to="/">Home</Button>
      </ErrorBoundaryLayoutWrapper>
    </>
  );
};
